/**
 * Helper INTERNAL function to mimic the spread of an object whose properties may or may not come from property getters with a regular object
 * Must not be used outside of office-web-host, and can be deleted at any point.
 *
 * @param original Original object to spread whose properties may or may not be stored in its prototype
 * @param inject Object to inject/replace its properties on the original object
 * @returns A shallow copy of the original object with the added/replaced properties
 */
export function mergeObjects<T>(original: T, inject: Partial<T>): T {
  // Getting the keys of the original object regardless if it's a normal JS object or its props are fetched via property getters
  const keys = [
    ...Object.keys(original),
    ...Object.keys(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(original)))
  ];
  const workingCopy = {} as T;
  keys.forEach((key) => {
    if ((inject as any)[key] === undefined) {
      (workingCopy as any)[key] = (original as any)[key];
    }
  });

  for (const key in inject) {
    (workingCopy as any)[key] = (inject as any)[key];
  }

  return workingCopy;
}
